import * as React from 'react';

import Input from 'components/inputs/input/Input';
import FormField from 'components/form/form-field/FormField';

import { __t, applyTranslations } from 'utils/language';

import type { TextEntry } from 'types';

import './creator-proposal-notes.scss';

applyTranslations(require('./creator-proposal-notes.i18n.json'));

const SHORT_NOTE_LENGTH = 86;

type Props = {
  brandRepresentativeNote?: string | null,
  accountManagerNote?: string | null,
  isForBrand: boolean,
  onUpdate: (note?: string | null) => void
};

const CreatorProposalNotes = (
  {
    brandRepresentativeNote = '',
    accountManagerNote = '',
    isForBrand,
    onUpdate
  }: Props
) => {
  const [value, setValue] = React.useState((isForBrand
    ? brandRepresentativeNote
    : accountManagerNote) || '');
  const [isFocused, setFocused] = React.useState(false);

  const managerNoteLabel = (isForBrand)
    ? __t('creator_proposal_notes_v2.account_manager_note_get_label')
    : __t('creator_proposal_notes_v2.account_manager_note_set_label');

  const brandNoteLabel = (isForBrand)
    ? __t('creator_proposal_notes_v2.brand_representative_note_set_label')
    : __t('creator_proposal_notes_v2.brand_representative_note_get_label');

  const noteEditField = (
    <Input
      autoFocus={isFocused}
      value={value}
      width="responsive"
      multiline={isFocused || value.length > SHORT_NOTE_LENGTH}
      onChange={(event: React.SyntheticEvent<TextEntry>) => {
        setValue(event.currentTarget.value);
      }}
      onFocus={() => {
        setFocused(true);
      }}
      onBlur={() => {
        setFocused(false);
        onUpdate(value);
      }}
    />
  );

  const noteDisplay = (
    <div className="creator-proposal-notes__read-only">
      {(isForBrand
        ? accountManagerNote
        : brandRepresentativeNote) || '—'}
    </div>
  );

  return (
    <div className="creator-proposal-notes">
      <div className="creator-proposal-notes__note">
        <FormField
          label={managerNoteLabel}
          labelType="highlighted"
          direction="column"
          fontSize="small"
          showRequiredMark={false}
          showValidationIcon={false}
        >
          {isForBrand ? noteDisplay : noteEditField}
        </FormField>
      </div>
      <div className="creator-proposal-notes__note">
        <FormField
          label={brandNoteLabel}
          labelType="highlighted"
          direction="column"
          fontSize="small"
          showRequiredMark={false}
          showValidationIcon={false}
        >
          {isForBrand ? noteEditField : noteDisplay}
        </FormField>
      </div>
    </div>
  );
};

export default CreatorProposalNotes;
